@use "sass:color";

.promo-code-field {
  $dark-green: #2CBE60;
  $light-green: color.adjust($dark-green, $alpha: -0.85);
  $dark-red: #D0011B;
  $light-red: #EED4D4;
  text-align: left;
  margin-top: 0.5em;

  a {
    color: #222;
    font-size: 0.8em;
  }

  .input-line {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .input-group {
    transition: all .5s ease-in-out;

    overflow: hidden;
    max-height: 0;

    &.show {
      max-height: 200px;
    }
  }

  input[type="text"] {
    margin-right: 1em;
  }

  input[type="button"] {
    position: relative;
    z-index: 3;
  }

  label {
    font-size: 18px;
  }

  &.success {
    input[type="text"] {
      border-color: $dark-green;
      color: $dark-green;

      // Required for Safari.
      -webkit-text-fill-color: $dark-green;
      opacity: 1;

      &:focus {
        border-color: $dark-green !important;
      }
    }
    .infobox {
      background-color: $light-green;
      color: $dark-green;
    }
  }

  &.error {
    input[type="text"] {
      border-color: $dark-red;
      color: $dark-red;

      &:focus {
        border-color: $dark-red !important;
      }
    }
    .infobox {
      background-color: $light-red;
      color: $dark-red;
    }
  }

  .infobox {
    display: flex;
    align-items: center;
    font-size: 16px;
    margin-top: 0.625em; // 10px
    padding: 0.5em 1.25em 0.5em 1.25em; // 8px 20px 8px 20px
    border-radius: 4px;

    .checkmark svg {
      display: flex;
      align-items: center;
      width: 20px;
      margin-right: 14px;
      * {
        fill: $dark-green;
      }
    }
  }
}
